// Copyright © 2021 Move Closer
import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
/**
 * Simple component capable of rendering the form's errors
 * passed as an array of strings.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
let FormErrors = class FormErrors extends Vue {
};
__decorate([
    Prop({ type: Array, required: false, default: () => [] })
], FormErrors.prototype, "errors", void 0);
FormErrors = __decorate([
    Component({
        name: 'FormErrors',
        template: `
    <ul class="list-unstyled text-danger font-weight-bold">
      <li v-for="error in errors" :key="error">
        {{ error }}
      </li>
    </ul>
  `
    })
], FormErrors);
export { FormErrors };
